import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Array$from from 'babel-runtime/core-js/array/from';
import _Set from 'babel-runtime/core-js/set';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _Map from 'babel-runtime/core-js/map';
import _difference from 'lodash/difference';
import _memoize from 'lodash/memoize';
import _flattenDeep from 'lodash/flattenDeep';
import _toString from 'lodash/toString';
import _toArray from 'lodash/toArray';
import PropTypes, { checkPropTypes } from 'prop-types';


var valuesSeparator = /\s+/;

var makeOutfitParser = function makeOutfitParser() {
  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  checkPropTypes(makeOutfitParserType, { params: params }, 'parameter', 'makeOutfitParser()');
  var config = new _Map(params);

  return _memoize(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var attributes = _toString(value).split(valuesSeparator);
    return attributes.reduce(parse(config), getSchema(config));
  });
};

var makeOutfitParserType = {
  params: PropTypes.arrayOf(PropTypes.array).isRequired
};

var parse = function parse(config) {
  return function (acc, attr) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(config), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var _ref2$ = _ref2[0];
        var key = _ref2$ === undefined ? '' : _ref2$;
        var _ref2$2 = _ref2[1];
        _ref2$2 = _ref2$2 === undefined ? {} : _ref2$2;
        var _ref2$2$values = _ref2$2.values;
        var values = _ref2$2$values === undefined ? [] : _ref2$2$values;
        var multiple = _ref2$2.multiple;

        if (values.includes(attr)) {
          if (!multiple) acc.get(key).clear();
          acc.get(key).add(attr);
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return acc;
  };
};

var getSchema = function getSchema() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var result = new _Map();
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _getIterator(config), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref3 = _step2.value;

      var _ref4 = _slicedToArray(_ref3, 1);

      var _ref4$ = _ref4[0];
      var key = _ref4$ === undefined ? '' : _ref4$;

      result.set(key, new _Set());
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
};

/**
 * Helper function for constructing config entries.
 * @param name Category name
 * @param values Available values
 * @param multiple Indicates whether multiple values can be active.
 * @return Category entry structure.
 */
var category = function category(name, values) {
  var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  checkPropTypes(categoryType, { name: name, values: values, multiple: multiple }, 'parameter', 'category()');
  return [name || '', {
    values: _toArray(values),
    multiple: Boolean(multiple)
  }];
};

var categoryType = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  multiple: PropTypes.bool
};

var flattenValues = _memoize(function (parsedOutfit) {
  return _flattenDeep(_Array$from(parsedOutfit.values()).map(function (value) {
    return _Array$from(value);
  }));
});

/**
 * Helper function for resolving preset to specific values
 * @param {string} outfit Un-parsed outfit
 * @param {string} preset Preset to be resolved
 * @param {string} resolvedValues Resolved values that will replace preset.
 * @return {string}
 */
var replaceValue = function replaceValue(outfit, preset, resolvedValues) {
  if (!preset || !resolvedValues) return outfit;
  var pickPreset = new RegExp('(\\s|^)' + preset + '(\\b(?!-))', 'g');
  return outfit.replace(pickPreset, '$1' + resolvedValues);
};

var notAllowed = function notAllowed(allowedOptions, outfitString) {
  var uniqueOptions = [].concat(_toConsumableArray(new _Set(allowedOptions)));
  var givenOptions = outfitString.split(valuesSeparator).filter(Boolean);
  return _difference(givenOptions, uniqueOptions);
};

export { makeOutfitParser, category, flattenValues, notAllowed, replaceValue };